import Vue from "vue";
import Vuex from "vuex";
import tabberStore from "@/store/index";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    socketRun: false,
    socketTast: null,
    websocketData: {}, // 存放从后端接收到的websocket数据
    noReadNum: 0,
    WebSocketUrl: "",
    ping: "",
    tryStart: null,
    refreshNoticeInfo: {
      resumeUnreadNum: 0,
    },
  },
  mutations: {
    SET_VAL: (state, { key, value }) => {
      if (state.hasOwnProperty(key)) {
        state[key] = value;
      }
    },
    setWebsocketData(state, data) {
      state.websocketData = data;
    },
    setWebsocketRun(state, runStatus) {
      state.socketRun = runStatus;
    },
    setNoReadNum(state, num) {
      state.noReadNum = num;
    },
    setNoticeInfo(state, info) {
      state.refreshNoticeInfo = info;
    },
    setUrl(state, url) {
      state.WebSocketUrl = url;
    },
  },
  actions: {
    websocketInit({ state, dispatch, commit }, url) {
      var num = 0;
      return new Promise(function (resolve, reject) {
        commit("setUrl", url);
        let tryStart = setInterval(() => {
          if (!state.socketRun) {
            console.log("断线重连", num);
            if (num >= 20) {
              clearInterval(tryStart);
              reject();
            } else {
              console.log("websocketLink");
              dispatch("websocketLink").then(() => {
                clearInterval(tryStart);
                setTimeout(() => {
                  resolve();
                }, 200);
              });
              num = num + 1;
            }
          }
        }, 500);

        commit("SET_VAL", { key: "tryStart", value: tryStart });
      });
    },

    websocketLink({ state, dispatch, commit }) {
      return new Promise(function (resolve, reject) {
        if (state.socketRun) {
          resolve();
          return;
        }
        var url = state.WebSocketUrl;
        console.log(url);
        // commit('setUrl', url)

        state.socketTast = uni.connectSocket({
          url: url, // url是websocket连接ip
          success: () => {
            console.log("连接成功");
            resolve();
          },
          fail: (e) => {
            reject();
            console.log("连接失败");
            console.log(e);
          },
        });

        state.socketTast.onMessage((res) =>
          dispatch("websocketOnMessage", res)
        );

        state.socketTast.onOpen(() => {
          commit("setWebsocketRun", true);
          resolve();
          dispatch("websocketOnOpen");
        });

        state.socketTast.onClose((e) => {
          dispatch("websocketOnClose", e);
        });
        state.socketTast.onError((e) => {
          dispatch("websocketOnError", e);
          // clearInterval(ping)
        });
      });
    },

    websocketOnOpen({ commit, dispatch }) {
      console.log("WebSocket连接正常打开中...！");
      store.dispatch("websocketSend", { cmd: "init", data: {} });

      let ping = setInterval(() => {
        dispatch("webSocketPing");
      }, 5000);
      commit("SET_VAL", { key: "ping", value: ping });
    },
    // 收到数据
    websocketOnMessage({ commit }, res) {
      // console.log('收到服务器内容：' + res.data)
      let data = JSON.parse(res.data);
      if (data.cmd == "noReadNum") {
        let noReadNum = data.data.no_read_num;
        commit("setNoReadNum", noReadNum);
        tabberStore.commit("setNoReadNumTabbar", noReadNum);
        // commit('setNoReadNum', data.data.no_read_num)
      }
    },
    websocketOnClose({ commit, dispatch, state }, e) {
      console.log("WebSocket连接关闭", e);
      commit("setWebsocketRun", false);
    },
    websocketOnError({ commit, dispatch }, e) {
      console.log("WebSocket连接错误", e);
      commit("setWebsocketRun", false);
    },
    websocketClose({ state, commit }) {
      return new Promise(function (resolve, reject) {
        clearInterval(state.tryStart);
        clearInterval(state.ping);
        if (!state.socketTast) return;
        state.socketTast.close({
          success(res) {
            console.log("关闭成功", res);
            commit("setWebsocketRun", false);
            resolve();
          },
          fail(err) {
            reject();
          },
        });
      });
    },
    // 发送数据
    websocketSend({ state, dispatch }, data) {
      return new Promise(function (resolve, reject) {
        if (typeof data == "object") {
          if (typeof data.token == "undefined") {
            data.token = uni.getStorageSync("token");
          }
          data = JSON.stringify(data);
        }

        uni.sendSocketMessage({
          data,
          success: (res) => {
            console.log("发送成功");
            resolve();
          },
          fail: (e) => {
            console.log("发送失败");
            dispatch("websocketLink");
            reject();
          },
        });
      });
    },

    webSocketPing({ state, dispatch }) {
      let data = JSON.stringify({ cmd: "ping", data: {} });
      dispatch("websocketSend", data);
    },

    changeNoReadNum({ state, commit }, num) {
      commit("setNoReadNum", num);
      tabberStore.commit("setNoReadNumTabbar", num);
    },

    refreshNotice({ state, commit }, info) {
      commit("setNoticeInfo", info);
      commit("setNoReadNum", info.chatUnreadNum);
      tabberStore.commit("setNoReadNumTabbar", info.chatUnreadNum);
    },
  },
});

export default store;
